import ProductAccordion from "@root/modules/OpenProductPage/ProductAccordion";
import ProductColorChange from "@root/modules/OpenProductPage/ProductColorChange";
import CertificatesAccordionBlock from "@root/blocks/CertificatesAccordion";
import ProductSlider from "@root/blocks/ProductSlider";
new ProductAccordion();
new ProductColorChange();
var certificatesAccordionBlocks = document.querySelectorAll('[data-certificates-accordion-block]');
if (certificatesAccordionBlocks.length === 1) {
    certificatesAccordionBlocks.forEach(function (accordionBlock) {
        new CertificatesAccordionBlock(accordionBlock);
    });
}
var productSliderBlocks = document.querySelectorAll('[data-product-slider-block]');
if (productSliderBlocks.length > 0) {
    productSliderBlocks.forEach(function (sliderBlock) {
        new ProductSlider(sliderBlock);
    });
}
// slide to block function on .action-button press if action button exists
var actionButtonsWrapper = document.querySelector('.open-product-action-buttons');
if (actionButtonsWrapper) {
    var actionButton = actionButtonsWrapper.querySelectorAll('a');
    actionButton.forEach(function (button) {
        button.addEventListener('click', function (event) {
            if (!button.getAttribute('href').includes('#')) {
                return;
            }
            event.preventDefault();
            var targetBlock = button.getAttribute('href');
            var targetElement = document.querySelector(targetBlock);
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' });
            }
        });
    });
}
